import { render, staticRenderFns } from "./Gmrk.vue?vue&type=template&id=2e0981b8&scoped=true&"
import script from "./Gmrk.vue?vue&type=script&lang=js&"
export * from "./Gmrk.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e0981b8",
  null
  
)

export default component.exports